import React, { useState } from 'react';
import Dropzone from 'react-dropzone';

const MAX_UPLOAD_BYTES = 10 * 1024 * 1024;

async function uploadAndParse({ file, team, user }) {
    const token = await user.getIdToken();
    const form = new FormData();
    form.append('file', file, file.name);
    form.append('team', team);
    form.append('displayName', file.name);

    const res = await fetch('/api/heatsheets', {
        method: 'POST',
        headers: { 'Authorization': `Bearer ${token}` },
        body: form,
    });
    if (!res.ok) {
        const txt = await res.text();
        throw new Error(`Upload failed (HTTP ${res.status}): ${txt}`);
    }
}

export default function DropHeatsheet({ team, user }) {
    const [error, setError] = useState(null);
    const [busy, setBusy] = useState(false);

    const onDropAccepted = async (files) => {
        if (!team || !user) {
            setError('Not signed in as a controller for this team');
            return;
        }
        setBusy(true);
        setError(null);
        try {
            await uploadAndParse({ file: files[0], team, user });
        } catch (e) {
            setError(e.message || String(e));
        } finally {
            setBusy(false);
        }
    };

    const message = busy
        ? 'Uploading…'
        : 'Drag a heatsheet PDF or meet JSON, or click to select one';

    return (
        <>
            <Dropzone
                multiple={false}
                accept={{
                    'application/pdf': ['.pdf'],
                    'application/json': ['.json'],
                }}
                maxSize={MAX_UPLOAD_BYTES}
                onDropAccepted={onDropAccepted}
                onDropRejected={(rejected) => {
                    const why = rejected[0]?.errors?.[0]?.message || 'File rejected';
                    setError(why);
                }}
                disabled={busy}
            >
                {({ getRootProps, getInputProps }) => (
                    <section>
                        <div {...getRootProps()} className="dropContianer">
                            <input {...getInputProps()} />
                            <div style={{ height: '4vh' }} />
                            <p className="inner">{message}</p>
                            <div style={{ height: '4vh' }} />
                        </div>
                    </section>
                )}
            </Dropzone>
            {error && (
                <p style={{ color: 'crimson', marginTop: '1rem' }}>{error}</p>
            )}
        </>
    );
}
